import React from 'react'

import ProductView from 'src/modules/buyer/modules/suppliers/components/ProductView'

const PublicProductView = props => {
  return <ProductView {...props} showPrice={false} linkPrefix="/public" />
}

export default PublicProductView
